import ModalInfo from 'components/shared/ModalInfo'
import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import { useState, useEffect } from 'react'
import { handleError } from 'helpers/errors'
import { useDeleteSelfcareOrderPositionsMutation } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { useNavigate } from 'react-router-dom'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { setIsCancelYourVisitModalOpen } from 'store/general-slice'
import { useSelfcareCart } from 'store/selfcare-cart-slice/hooks'
import { SelfcareAccomodationCancellation } from 'components/global/SelfcareAccomodationCancellation'
import { Languages } from 'helpers/enum'

const CancelYourVisitModal = () => {
    const [isRefetchAfterCancelActive, setIsRefetchAfterCancelActive] =
        useState(false)

    const { isCancelYourVisitModalOpen } = useAppSelector(
        (state) => state.general
    )
    const { formatMessage } = useIntl()
    const { getPath, language } = useApp()
    const [cancelVisit, status] = useDeleteSelfcareOrderPositionsMutation()
    const { refetchPositions } = useSelfcare()
    const { isSelfcareCartFetching } = useSelfcareCart()
    const { isLoading: isDeleteOrderPositionsProcessing } = status
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { hasAccommodation } = useAppSelector((state) => state.selfcare)

    const handleCancelVisit = async () => {
        try {
            const response = await cancelVisit({ _locale: language })
            handleError(response)
            refetchPositions()
            setIsRefetchAfterCancelActive(true)
        } catch (error) {
            setIsRefetchAfterCancelActive(false)
        }
    }

    useEffect(() => {
        if (!isSelfcareCartFetching && isRefetchAfterCancelActive) {
            dispatch(setIsCancelYourVisitModalOpen(false))
            navigate(getPath('selfcare_order'))
        }
    }, [isSelfcareCartFetching, isRefetchAfterCancelActive])

    return (
        <ModalInfo
            isOpened={isCancelYourVisitModalOpen}
            linkLabel={formatMessage({
                id: 'global.btn.back_to_reservation',
                defaultMessage: 'Wróć do rezerwacji',
            })}
            buttonLabel={formatMessage({
                id: 'global.btn.cancel_visit',
                defaultMessage: 'Anuluj pobyt',
            })}
            onLinkClick={() => dispatch(setIsCancelYourVisitModalOpen(false))}
            onButtonClick={handleCancelVisit}
            variant="primary"
            isLoading={
                isDeleteOrderPositionsProcessing || isSelfcareCartFetching
            }
            testIdPrefix="selfcare-cancel-visit-modal"
            width={560}
            hasButtonsNoWrap={language !== Languages.UK}
        >
            <Text variant="heading3">
                {formatMessage({
                    id: 'selfcare.modal.cancel_your_visit_title',
                    defaultMessage: 'Czy na pewno chcesz anulować pobyt?',
                })}
            </Text>
            <Text variant="body" mt={16} color="grayscale_900">
                {formatMessage({
                    id: 'selfcare.modal.cancel_your_visit_subtitle',
                    defaultMessage:
                        'Anulowanego pobytu nie można przywrócić. Zwrot środków otrzymasz w formie vouchera.',
                })}
            </Text>
            {hasAccommodation && <SelfcareAccomodationCancellation />}
        </ModalInfo>
    )
}

export default CancelYourVisitModal
